import { endOfTheWeek, formatDateToString, startOfTheWeek } from '@/utils/calendar';

/**
 * Hasura `where` clause matching the default week scope in {@link useActions}:
 * event start in / overlapping the calendar week, or weekly_plan bounds for that week.
 */
export function buildWeeklyActionsScopeWhere(selectedDate: Date) {
  return {
    _or: [
      {
        // Only RECURRING series need to be pulled in from before this week — they recur
        // forward into it. A past one-off action does not, so without this recurrence
        // bound the query fetched the account's entire action history (every past-started
        // action) only to discard it client-side: the dominant load-time cost for
        // long-used accounts. Actions starting within this week are still fetched by the
        // next clause regardless of recurrence.
        event: {
          start: {
            _lt: formatDateToString(selectedDate),
          },
          recurrence: {
            _isNull: false,
          },
        },
      },
      {
        event: {
          start: {
            _gte: formatDateToString(startOfTheWeek(selectedDate)),
            _lte: formatDateToString(endOfTheWeek(selectedDate)),
          },
        },
      },
      {
        weekly_plan: {
          dateFrom: { _eq: formatDateToString(startOfTheWeek(selectedDate)) },
          dateTo: { _eq: formatDateToString(endOfTheWeek(selectedDate)) },
        },
      },
    ],
  };
}
